// extracted by mini-css-extract-plugin
module.exports = {"Author":"styles_Author__lWwK8","small":"styles_small__4SSJJ","image":"styles_image__twwPZ","names":"styles_names__ayQpb"};